import { defineReactiveModel, Persistable } from "vue-app-utils";
import Model from "@/models/model";

const Payment = {
  extends: Model,
  mixins: [
    Persistable
  ]
};

export default defineReactiveModel(Payment);
